import { gql } from 'graphql-request';

export const EQUIPMENT_FIELDS = gql`
  fragment EquipmentFields on EquipmentDto {
    equipmentId
    name
    supplierOwner
    time
    hoursUsed
    amount
    costPerHour
    pricePerHour
    taskId
    chargeToClient
  }
`;

export const getEquipments = gql`
  query getEquipments($taskId: String!) {
    getEquipments(taskId: $taskId) {
      ...EquipmentFields
    }
  }
  ${EQUIPMENT_FIELDS}
`;

export const updateEquipment = gql`
  mutation UpdateEquipment($equipment: EquipmentUpdateInput!) {
    updateEquipment(equipment: $equipment) {
      ...EquipmentFields
    }
  }
  ${EQUIPMENT_FIELDS}
`;

export const createEquipment = gql`
  mutation createEquipment($equipment: EquipmentCreateInput!) {
    createEquipment(equipment: $equipment) {
      ...EquipmentFields
    }
  }
  ${EQUIPMENT_FIELDS}
`;

export const deleteEquipment = gql`
  mutation deleteEquipment($id: String!) {
    deleteEquipment(id: $id) {
      affected
    }
  }
`;

const EquipmentGraphQL = {
  queries: {
    getEquipments,
  },
  mutations: {
    createEquipment,
    updateEquipment,
    deleteEquipment,
  },
};

export default EquipmentGraphQL;
